import { useLocation, useNavigate } from 'react-router-dom';

import { PATH } from 'constants/path';

export const useContentController = () => {
  const navigationTo = useNavigate();

  const location = useLocation();

  const onTabClick = (key: string) => {
    navigationTo(key);
  };

  const isExcercisesPath = location.pathname.includes(PATH.EXERCISES);

  const isLessonsPath = location.pathname.includes(PATH.LESSONS);

  const isCoursesPath = location.pathname.includes(PATH.COURSES);

  const isFunctionalTestPath = location.pathname.includes(PATH.FUNCTIONAL_TESTS);

  const isAssessmentsPath = location.pathname.includes(PATH.ASSESSMENTS);

  const onClickAddItem = () => {
    switch (true) {
      case isExcercisesPath:
        navigationTo(`${PATH.EXERCISES}/${PATH.ADD_EXERCISES}`);
        break;

      case isLessonsPath:
        navigationTo(`${PATH.LESSONS}/${PATH.ADD_LESSONS}`);
        break;

      case isCoursesPath:
        navigationTo(`${PATH.COURSES}/${PATH.ADD_COURSES}`);
        break;

      case isFunctionalTestPath:
        navigationTo(`${PATH.FUNCTIONAL_TESTS}/${PATH.ADD_FUNCTIONAL_TESTS}`);
        break;

      case isAssessmentsPath:
        navigationTo(`${PATH.ASSESSMENTS}/${PATH.ADD_ASSESSMENTS}`);
        break;

      default:
        break;
    }
  };

  return {
    onTabClick,
    onClickAddItem,
    locationPath: location.pathname,
  };
};
